// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ARTICLES_TITLE = "\u010cl\u00e1nky";
export const STROLLER_SEO_GENERAL_DESC = "Ve\u013ek\u00e1 datab\u00e1za ko\u010d\u00edkov Modr\u00e9ho kon\u00edka";
